import RcTooltip from 'rc-tooltip';
import { ReactElement } from 'react';

interface Props {
    tooltip: string;
    children: ReactElement;
    placement?: string;
    wrap?: boolean;
}

export default function Tooltip({ tooltip, children, placement = 'left', wrap = false }: Props) {
    if (wrap) {
        children = <span>{children}</span>;
    }

    return <RcTooltip
        overlay={tooltip}
        placement={placement}
        getTooltipContainer={(dom) => {
            return dom.parentElement || document.body;
        }}
    >
        {children}
    </RcTooltip>;
}
